import { Navigate, Route, Routes } from 'react-router-dom';
import { RequirePage } from './components/RequirePage';
import { useAuth } from './context/AuthContext';
import { ApprovalsPage } from './pages/ApprovalsPage';
import { AssetsPage } from './pages/AssetsPage';
import { CashLedgerPage } from './pages/CashLedgerPage';
import { ContractsPage } from './pages/ContractsPage';
import { ConsolidatedReportsPage } from './pages/ConsolidatedReportsPage';
import { DashboardPage } from './pages/DashboardPage';
import { GuidePage } from './pages/GuidePage';
import { HrPage } from './pages/HrPage';
import { LedgerPage } from './pages/LedgerPage';
import { LoginPage } from './pages/LoginPage';
import { MyPayslipsPage } from './pages/MyPayslipsPage';
import { PaymentsPage } from './pages/PaymentsPage';
import { PayrollDetailPage } from './pages/PayrollDetailPage';
import { PayrollPage } from './pages/PayrollPage';
import { ProjectReceivablesPage } from './pages/ProjectReceivablesPage';
import { BusinessTravelSettlementPage } from './pages/BusinessTravelSettlementPage';
import { PlaceholderPage } from './pages/PlaceholderPage';
import { ReportsPage } from './pages/ReportsPage';
import { SettingsPage } from './pages/SettingsPage';
import { SsoCallbackPage } from './pages/SsoCallbackPage';

/**
 * App shell — routing + guard.
 * Mọi trang bảo vệ qua <RequirePage page="..."> — check `user.pages` từ server.
 */
export function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center', color: '#64748b', fontFamily: 'Inter, sans-serif' }}>
        Đang kiểm tra phiên đăng nhập...
      </div>
    );
  }

  // Landing sau login: NV → mypayslips (không có dashboard); còn lại → dashboard
  const home = user?.role === 'NV' ? '/mypayslips' : '/dashboard';

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to={home} replace /> : <LoginPage />} />
      <Route path="/sso/callback" element={<SsoCallbackPage />} />

      <Route path="/dashboard" element={<RequirePage page="dashboard"><DashboardPage /></RequirePage>} />
      <Route path="/approvals" element={<RequirePage page="approvals"><ApprovalsPage /></RequirePage>} />
      <Route path="/payments" element={<RequirePage page="payments"><PaymentsPage /></RequirePage>} />
      <Route path="/cashledger" element={<RequirePage page="cashledger"><CashLedgerPage /></RequirePage>} />
      <Route path="/ledger" element={<RequirePage page="ledger"><LedgerPage /></RequirePage>} />
      <Route path="/payroll" element={<RequirePage page="payroll"><PayrollPage /></RequirePage>} />
      <Route path="/payroll/:id" element={<RequirePage page="payroll"><PayrollDetailPage /></RequirePage>} />
      <Route path="/mypayslips" element={<RequirePage page="mypayslips"><MyPayslipsPage /></RequirePage>} />
      <Route path="/contracts" element={<RequirePage page="contracts"><ContractsPage /></RequirePage>} />
      <Route path="/congnoda" element={<RequirePage page="congnoda"><ProjectReceivablesPage /></RequirePage>} />
      <Route path="/assets" element={<RequirePage page="assets"><AssetsPage /></RequirePage>} />
      <Route path="/hr" element={<RequirePage page="hr"><HrPage /></RequirePage>} />
      <Route path="/congtacqt" element={<RequirePage page="congtacqt"><BusinessTravelSettlementPage /></RequirePage>} />
      <Route path="/vaynh" element={<RequirePage page="vaynh"><PlaceholderPage title="Vay ngân hàng" subtitle="Khoản vay · Lãi vay · Lịch trả nợ" description="Theo dõi các hợp đồng vay ngân hàng: gốc + lãi suất + lịch trả · Alert kỳ trả nợ · Bút toán TK 341/635 tự động." /></RequirePage>} />
      <Route path="/reports" element={<RequirePage page="reports"><ReportsPage /></RequirePage>} />
      <Route path="/hopnhat" element={<RequirePage page="hopnhat"><ConsolidatedReportsPage /></RequirePage>} />
      <Route path="/settings" element={<RequirePage page="settings"><SettingsPage /></RequirePage>} />
      <Route path="/guide" element={<RequirePage page="guide"><GuidePage /></RequirePage>} />

      <Route path="/" element={<Navigate to={user ? home : '/login'} replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
